import {
  Outlet,
  RouterProvider,
  createRootRoute,
  createRoute,
  createRouter,
  redirect,
} from "@tanstack/react-router";

import { AppNav } from "@/components/AppNav";
import { InseratePage } from "@/pages/InseratePage";
import { ObjektDetailPage } from "@/pages/ObjektDetailPage";
import { ObjektePage } from "@/pages/ObjektePage";

/** Authenticated-area router. Rendered by `<App>` only when the auth context
 * reports `status === "authenticated"`, so we don't need beforeLoad guards on
 * every route — the unauth case never reaches the router. */

const rootRoute = createRootRoute({
  component: () => (
    <>
      <AppNav />
      <Outlet />
    </>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  // Default landing in the SPA: the triage queue
  beforeLoad: () => {
    throw redirect({ to: "/inserate" });
  },
});

const inserateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/inserate",
  component: InseratePage,
});

const objekteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/objekte",
  component: ObjektePage,
});

const objektDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/objekte/$slug",
  component: function ObjektDetailRouteComponent() {
    const { slug } = objektDetailRoute.useParams();
    return <ObjektDetailPage slug={slug} />;
  },
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  inserateRoute,
  objekteRoute,
  objektDetailRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function AppRouter() {
  return <RouterProvider router={router} />;
}
